import { Component, OnInit, Input, HostBinding, Output, EventEmitter } from "@angular/core";
import { trigger, state, style, animate, transition } from "@angular/animations";
import { LocalStorage } from "@ngx-pwa/local-storage";

@Component({
    selector: "app-view-tutorial",
    template: `<div class="modal" [@changeState]="state" (@changeState.done)="animationDone($event)" *ngIf="visible">
        <div class="p-normal">
            <fa-icon size="3x" class="text-primary-500" [icon]="icon"></fa-icon>

            <h1 class="text-xl sm:text-3xl font-bold text-primary-500 mb-1">{{ title }}</h1>
            <p class="text-base mb-1">{{ lead }}</p>
            <p class="text-sm mb-3 text-gray-500"><ng-content></ng-content></p>

            <ion-button color="primary" class="button-tutorial-close" (click)="onHide()">{{ button }}</ion-button>
        </div>
    </div> `,
    styles: [
        `
            .modal {
                position: fixed;
                top: 0px;
                bottom: 0px;
                left: 0px;
                right: 0px;
                background: var(--ion-background-color);
                z-index: 200;
                display: flex;
                justify-content: center;
                align-items: center;
                pointer-events: all;
            }
        `,
    ],
    animations: [trigger("changeState", [state("in", style({ opacity: 1 })), state("hidden", style({ opacity: 0 })), transition("*=>hidden", animate("300ms"))])],
})
export class ViewTutorialComponent implements OnInit {
    @Input() title = "";
    @Input() lead = "";
    @Input() description = "";
    @Input() button = "";
    @Input() icon: any;
    @Output() action: EventEmitter<void> = new EventEmitter<void>();

    visible = false;

    state = "hidden";
    private key = "";
    constructor(protected localStorage: LocalStorage) {}

    async ngOnInit() {
        this.key = "ywc::tutorial::" + this.slugify(this.title);

        const tutorial = await this.localStorage.getItem(this.key).toPromise();

        if ((<any>window).Cypress) {
            this.state = "hidden";
            this.visible = false;
        } else if (!tutorial) {
            this.state = "in";
            this.visible = true;
        }
    }

    onHide() {
        this.state = "hidden";
        this.localStorage.setItem(this.key, "1").toPromise();
        this.action.emit();
    }
    animationDone(event) {
        if (this.state === "hidden") {
            this.visible = false;
        }
    }

    private slugify(text) {
        return text
            .toString()
            .toLowerCase()
            .replace(/\s+/g, "-") // Replace spaces with -
            .replace(/[^\w\-]+/g, "") // Remove all non-word chars
            .replace(/\-\-+/g, "-") // Replace multiple - with single -
            .replace(/^-+/, "") // Trim - from start of text
            .replace(/-+$/, ""); // Trim - from end of text
    }
}
